export default {
  index: 5,
  meta: {
    label: '云桌面',
    icon: 'res-vminstance',
    catalog: 'rdp',
  },
  menus: [
    {
      meta: {
        label: '云桌面',
      },
      submenus: [
        {
          path: '/rdp/desktop',
          meta: {
            label: '我的云桌面',
            icon: 'res-systemuser',
            permission: 'rdp_resource_list',
          },
          component: () => import('@WinRD/views/myspace/index.vue'),
        },
      ],
    },
    {
      meta: {
        label: '云桌面资源管理',
      },
      submenus: [
        {
          path: '/rdp/accounts',
          meta: {
            label: '云桌面账号管理',
            icon: 'res-group',
            permission: 'rdp_management_update',
          },
          component: () => import('@WinRD/views/accounts/index.vue'),
        },
        {
          path: '/rdp/nodes',
          meta: {
            label: '云桌面节点管理',
            icon: 'res-instancegroup',
            permission: 'rdp_management_update',
          },
          component: () => import('@WinRD/views/nodes/index.vue'),
        },
      ],
    },
  ],
}
